module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_ko-1f68b2a8a72140e49bf30f75e720059b.jpg";